module.exports = __webpack_public_path__ + "static/media/OpenDyslexic-Italic.f5aa9f9a.otf";